// extracted by mini-css-extract-plugin
export default {"resetPasswordButton":"components-auth-styles-auth-module__resetPasswordButton--yZgF8ok4eY6xiwrF1ppMIg=="};